import api from "@api";
import { components } from "@api/schema";
import { IRecordEvent, IRecordEventList } from "../types/event.types";

export type IEvent = components["schemas"]["event"];
export type IEventMetadata = IEvent["payload"]["metadata"];

const METADATA_HEADERS: {
  [key in keyof Partial<IEventMetadata>]: string;
} = {
  system: "X-System",
  deviceType: "X-Device-Type",
  userAgent: "User-Agent",
  ip: "X-Forwarded-For",
  context: "X-Context",
};

export const publish = <T extends IRecordEvent<keyof IRecordEventList>>(
  event: T
) => {
  return api.post<T, null>("/events", event);
};

export const setMetadataHeaders = (metadata: Partial<IEventMetadata>) => {
  Object.entries(metadata).forEach(([key, value]) => {
    if (value) {
      api.setHeader(METADATA_HEADERS[key], String(value));
    }
  });
};
